import React from 'react';
import {Alert} from 'componentLibrary';
import {Grid, Button, Divider, Icon, Header} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import SuborgProgram from 'app-ui-componentlibrary/dist/go/components/common/SuborgProgram';
import {isValidDuns} from 'common/utils';
import _ from 'lodash';

const OrganizationCard = ({
  successType,
  organization,
  programNameList,
  dunsToUEIToggle,
}) =>
  (organization !== undefined && organization.mailingAddress !== null) ||
  organization.physicalAddress !== null ? (
    <div>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Header as="h3">
              {organization.displayName || organization.legalBusinessName}
            </Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="address-grid-row">
          <Grid.Column>
            {organization.mailingAddress
              ? organization.mailingAddress.addressLine1
              : null}{' '}
            {organization.mailingAddress
              ? organization.mailingAddress.addressLine2
              : null}{' '}
            {organization.mailingAddress ? organization.mailingAddress.city : null}{' '}
            {organization.mailingAddress
              ? organization.mailingAddress.stateOrProvince
              : null}{' '}
            {organization.mailingAddress ? organization.mailingAddress.zip : null}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="address-grid-row">
          <Grid.Column>
            {organization.physicalAddress
              ? organization.physicalAddress.addressLine1
              : null}{' '}
            {organization.physicalAddress
              ? organization.physicalAddress.addressLine2
              : null}{' '}
            {organization.physicalAddress ? organization.physicalAddress.city : null}{' '}
            {organization.physicalAddress
              ? organization.physicalAddress.stateOrProvince
              : null}{' '}
            {organization.physicalAddress ? organization.physicalAddress.zip : null}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={dunsToUEIToggle ? 3 : 2}>
          {dunsToUEIToggle && (
            <Grid.Column>
              <span className="orgInfo-header">UEI-EFT</span>
              <div className="orgInfo-data">
                {organization.uei
                  ? organization.uei +
                    (!_.isEmpty(_.trim(organization.eft)) ? '-' + organization.eft : '')
                  : ''}
              </div>
            </Grid.Column>
          )}
          <Grid.Column>
            <span className="orgInfo-header">DUNS#</span>
            <div className="orgInfo-data">
              {organization.duns || organization.dunsNumber}
              {isValidDuns(organization.eft, true) && organization.eft}
            </div>
          </Grid.Column>
          <Grid.Column></Grid.Column>
        </Grid.Row>
        {successType ? (
          <div className="program-grid-row">
            <Grid.Row>
              <Header as="h5">Assigned programs:</Header>
            </Grid.Row>
            <Grid.Row className="programs-row">
              <Grid.Column>
                {_.map(programNameList, (program, index) => {
                  return (
                    <div className="program-value" key={index}>
                      {program} <br />
                    </div>
                  );
                })}
              </Grid.Column>
            </Grid.Row>
          </div>
        ) : null}
      </Grid>
    </div>
  ) : (
    ''
  );

class ViewSubOrganization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      programList: false,
    };
  }

  handleProgramList = () => {
    this.setState({programList: true});
  };

  render() {
    const {
      alreadyAssociated,
      parentOrganizationId,
      organization,
      searchAgain,
      handleAddSubOrganization,
      addedSuccess,
      closeModal,
      foundInSAMGov,
      programs,
      programCheckedList,
      programNameList,
      programSelected,
      handlePrograms,
      handleProgramCheckbox,
      handleSelectProgram,
      handleGetAllPrograms,
      runValidation,
      errorPayload,
      getCurrentOrgDisplayName,
      dunsToUEIToggle,
      useSuborgToggle,
    } = this.props;
    const {programList} = this.state;
    return addedSuccess ? (
      <div className="subOrg-details-wrapper">
        <Alert
          size="tiny"
          header={`The following suborganization has been successfully added to ${getCurrentOrgDisplayName(
            parentOrganizationId
          )}`}
          type="success"
          dismissable={false}
        >
          <br />
          <OrganizationCard
            successType={addedSuccess}
            organization={organization}
            programNameList={programNameList}
            dunsToUEIToggle={dunsToUEIToggle}
          />
        </Alert>
        <br />
        <Button
          primary
          icon
          id="viewaddedSuborganizationPage"
          className="modalBtn"
          title="View added suborganization page"
          as={Link}
          to={`/subOrganization/${parentOrganizationId}/${organization.organizationId}`}
        >
          View added suborganization's page
        </Button>
        {`  `}
        <a id="viewSubOrganization" href="#" onClick={() => closeModal()}>
          Return to all suborganizations
        </a>
      </div>
    ) : (
      !_.isNil(alreadyAssociated) && (
        <div className="subOrg-details-wrapper">
          <Divider />
          {alreadyAssociated ? (
            <React.Fragment>
              <Alert
                size="tiny"
                header="An organization with the matching details already exist in your suborganization list."
                type="info"
                dismissable={false}
              >
                <br />
                <br />
                <OrganizationCard
                  organization={organization}
                  dunsToUEIToggle={dunsToUEIToggle}
                />
              </Alert>
              <br />
              <br />
              <Button
                primary
                icon
                id="viewOrganizationPage"
                title="View organization page"
                as={Link}
                to={`/subOrganization/${parentOrganizationId}/${organization.organizationId}`}
              >
                View existing organization details page
              </Button>
              {`  `}
              <a
                id="viewSubOrganization_tryNewSearchAfterExistingFound"
                href="#/"
                onClick={(event) => searchAgain(event)}
              >
                <Icon name="undo" />
                Try a new search
              </a>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Header as="h5" id="instr-header">
                Is this the correct suborganization you would like to add?
              </Header>
              <OrganizationCard
                organization={organization}
                dunsToUEIToggle={dunsToUEIToggle}
              />
              <br />
              <br />
              <Button
                primary
                icon
                id="viewSubOrganization_yes"
                className="modalBtn"
                title="Yes"
                onClick={this.handleProgramList}
              >
                Yes <Icon name="checkmark" fitted />
              </Button>
              <a
                id="viewSubOrganization_tryNewSearchAfterFoundinDB"
                href="#/"
                onClick={(event) => searchAgain(event)}
              >
                <Icon name="undo" />
                No, try a new search
              </a>
              {programList ? (
                <React.Fragment>
                  <SuborgProgram
                    useSuborgToggle={useSuborgToggle}
                    programs={programs}
                    programCheckedList={programCheckedList}
                    programNameList={programNameList}
                    programSelected={programSelected}
                    handlePrograms={handlePrograms}
                    handleProgramCheckbox={handleProgramCheckbox}
                    handleSelectProgram={handleSelectProgram}
                    handleGetAllPrograms={handleGetAllPrograms}
                    displayError={errorPayload && errorPayload.programCheckedList}
                    errorMessage={errorPayload && errorPayload.programCheckedList}
                  />
                  <Button
                    primary
                    icon
                    id="viewSubOrganization_add"
                    title="Add suborganization"
                    onClick={() => {
                      let validation = runValidation(programCheckedList);
                      if (_.isEmpty(validation) === true && foundInSAMGov === false) {
                        handleAddSubOrganization(organization, programCheckedList);
                      }
                    }}
                  >
                    Add suborganization&nbsp;&nbsp;
                    <Icon name="checkmark" fitted />
                  </Button>
                </React.Fragment>
              ) : null}
            </React.Fragment>
          )}
        </div>
      )
    );
  }
}

export default ViewSubOrganization;
